import MainPage from "pages/MainPage/MainPage"
import Payment from "pages/Payment/Payment"
import CancelPayment from "pages/CancelPayment/CancelPayment"
import TimeIsUp from "pages/TimeIsUp/TimeIsUp"
import SuccessPayment from "pages/SuccessPayment/SuccessPayment"
import CancelRequest from "pages/CancelRequest/CancelRequest"
import QRPay from "pages/QRPay/QRPay"
import QRBol from "pages/QRBol/QRBol"
import CBU from "pages/CBU/CBU"
import searchPay from "pages/SearchPay/SearchPay"
import Canceled from "pages/Canceled/Canceled"
import Moc from "pages/Moc/Moc"

export const INDEX_ROUTE = "/"
export const PAYMENT_ROUTE = "/payment"
export const SEARCHPAY_ROUTE = "/search"

export const CANCEL_ROUTE = "/cancel"
export const TIMEISUP_ROUTE = "/timeisup"
export const SUCCESS_ROUTE = "/success"
export const CANCELREQUEST_ROUTE = "/cancelrequest"

export const QRPAY_ROUTE = "/qrpay"
export const QRBOL_ROUTE = "/qrbol"
export const CBU_ROUTE = "/cbu"
export const searchPay_ROUTE = "/searchPay"
export const SBPPAY_ROUTE = "/sbppay"
export const CANCELED_ROUTE = "/canceled"
export const MOC_ROUTE = "/moc"





export const mobileRoutes = [
    {
        path: INDEX_ROUTE + '/:id', 
        Component: MainPage
    },
    {
        path: PAYMENT_ROUTE, 
        Component: Payment,
    },
    {
        path: CANCEL_ROUTE, 
        Component: CancelPayment,
    },
    {
        path: TIMEISUP_ROUTE, 
        Component: TimeIsUp,
    },
    {
        path: SUCCESS_ROUTE + '/:orderId', 
        Component: SuccessPayment,
    },
    {
        path: CANCELREQUEST_ROUTE, 
        Component: CancelRequest,
    },
    {
        path: QRPAY_ROUTE + '/:orderId', 
        Component: QRPay
    },
    {
        path: QRBOL_ROUTE + '/:orderId', 
        Component: QRBol
    },
    {
        path: CBU_ROUTE + '/:orderId', 
        Component: CBU
    },
    {
        path: searchPay_ROUTE + '/:orderId', 
        Component: searchPay
    },
    {
        path: CANCELED_ROUTE + '/:orderId', 
        Component: Canceled
    },
    {
        path: MOC_ROUTE, 
        Component: Moc
    },
]